<template>
    <div class="social-btns d-flex align-center justify-center">
        <v-btn :width="small ? 30 : 40" :height="small ? 30 : 40" v-for="(item, i) in items" :key="'social-btn-' + i" tag="a" :target="capRunning ? '_system' : '_blank'" dark icon :href="item.url" style="background: rgba(0, 0, 0, 0.3)" :class="{'me-2': i != items.length-1, [item.color]: colored && item.color}">
            <svg v-if="item.icon === 'telegram'" fill="currentColor" xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 50 50" :width="iconSize + 'px'" :height="iconSize + 'px'"><path d="M46.137,6.552c-0.75-0.636-1.928-0.727-3.146-0.238l-0.002,0C41.708,6.828,6.728,21.832,5.304,22.445	c-0.259,0.09-2.521,0.934-2.288,2.814c0.208,1.695,2.026,2.397,2.248,2.478l8.893,3.045c0.59,1.964,2.765,9.21,3.246,10.758	c0.3,0.965,0.789,2.233,1.646,2.494c0.752,0.29,1.5,0.025,1.984-0.355l5.437-5.043l8.777,6.845l0.209,0.125	c0.596,0.264,1.167,0.396,1.712,0.396c0.421,0,0.825-0.079,1.211-0.237c1.315-0.54,1.841-1.793,1.896-1.935l6.556-34.077	C47.231,7.933,46.675,7.007,46.137,6.552z M22,32l-3,8l-3-10l23-17L22,32z"/></svg>
            <svg v-else-if="item.icon === 'tiktok'" fill="#ffffff" :width="iconSize + 'px'" :height="iconSize + 'px'" viewBox="0 0 512 512" id="icons" xmlns="http://www.w3.org/2000/svg"><path d="M412.19,118.66a109.27,109.27,0,0,1-9.45-5.5,132.87,132.87,0,0,1-24.27-20.62c-18.1-20.71-24.86-41.72-27.35-56.43h.1C349.14,23.9,350,16,350.13,16H267.69V334.78c0,4.28,0,8.51-.18,12.69,0,.52-.05,1-.08,1.56,0,.23,0,.47-.05.71,0,.06,0,.12,0,.18a70,70,0,0,1-35.22,55.56,68.8,68.8,0,0,1-34.11,9c-38.41,0-69.54-31.32-69.54-70s31.13-70,69.54-70a68.9,68.9,0,0,1,21.41,3.39l.1-83.94a153.14,153.14,0,0,0-118,34.52,161.79,161.79,0,0,0-35.3,43.53c-3.48,6-16.61,30.11-18.2,69.24-1,22.21,5.67,45.22,8.85,54.73v.2c2,5.6,9.75,24.71,22.38,40.82A167.53,167.53,0,0,0,115,470.66v-.2l.2.2C155.11,497.78,199.36,496,199.36,496c7.66-.31,33.32,0,62.46-13.81,32.32-15.31,50.72-38.12,50.72-38.12a158.46,158.46,0,0,0,27.64-45.93c7.46-19.61,9.95-43.13,9.95-52.53V176.49c1,.6,14.32,9.41,14.32,9.41s19.19,12.3,49.13,20.31c21.48,5.7,50.42,6.9,50.42,6.9V131.27C453.86,132.37,433.27,129.17,412.19,118.66Z"/></svg>
            <v-icon :size="iconSize" v-else>{{item.icon}}</v-icon>
        </v-btn>
    </div>
</template>

<script>

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'

export default {
    props: {
        colored: {type: Boolean, default: false},
        small: {type: Boolean, default: false},
    },
    data(){
        return {

        }
    },
    computed: {
        iconSize(){
            return this.small ? 17 : 23;
        },
        items(){
            let items = [];
            const appData = this.appData;
            if (appData.youtube_url){
                items.push({icon: 'mdi-youtube', url: appData.youtube_url, color: 'red darken-1'});
            }
            if (appData.facebook_url){
                items.push({icon: 'mdi-facebook', url: appData.facebook_url, color: 'indigo darken-1'});
            }
            if (appData.linkedin_url){
                items.push({icon: 'mdi-linkedin', url: appData.linkedin_url, color: 'blue darken-1'});
            }
            if (appData.telegram_url){
                items.push({icon: 'telegram', url: appData.telegram_url, color: 'blue'});
            }
            if (appData.messenger_url){
                items.push({icon: 'mdi-facebook-messenger', url: appData.messenger_url, color: 'blue lighten-1'});
            }
            if (appData.twitter_url){
                items.push({icon: 'mdi-twitter', url: appData.twitter_url, color: 'blue lighten-2'});
            }
            if (appData.tiktok_url){
                items.push({icon: 'tiktok', url: appData.tiktok_url, color: 'black'});
            }
            if (appData.whatsapp_url){
                items.push({icon: 'mdi-whatsapp', url: appData.whatsapp_url, color: 'green darken-1'});
            }
            return items;
        },
        ...GlobalComputed
    },
    methods: {
        ...GlobalMethods
    }
}
</script>

<style lang="scss" scoped>

</style>